import { Skeleton } from '@material-ui/lab'
import styled from 'styled-components'

export const CreateWrapper = styled.div`
    flex: 1;
    padding: 48px 24px;
    border-radius: 15px;
    min-width: 680px;
    background: ${({ theme }) => theme.colors.primaryWhite};
`

export const FormSkeleton = styled(Skeleton)`
    margin: 0 auto 12px;
    border-radius: 15px;
`
